<template>
    <div class="inline text-green-600 border border-green-600 px-2 text-xs ml-2">€</div>
</template>

<script>
    export default {
        name: "FilterEuroSymbol"
    }
</script>

<style scoped>

</style>